<template>
  <div>
    <img v-if="url" :src="url" />
    <gl-sub-text v-else>読込中...</gl-sub-text>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
    },
  },
}
</script>
